import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitch } from '@/components/language-switch';
import { useTorBlockStore } from '@/lib/api/tor-block';
import { ErrorCard } from './error-page';

/**
 * Shown when the API refused this client as a Tor user (#118 R35). It has no
 * URL and renders outside the router (it imports nothing from
 * react-router-dom), so it offers no home link, only the language switch.
 */
export function TorBlockedPage() {
  const { t } = useTranslation();
  return (
    <ErrorCard
      heading={/* This service is not available over Tor. */ t('torBlocked.title')}
      message={/* Please connect without Tor to continue. */ t('torBlocked.body')}
      headingSize="title"
    >
      <LanguageSwitch className="mx-auto mt-6 w-fit" />
    </ErrorCard>
  );
}

/** The root gate: renders `children` (the router) until a response says `TOR_BLOCKED`, then the block page. */
export function TorBlockGate({ children }: { children: ReactNode }) {
  const blocked = useTorBlockStore((s) => s.blocked);
  return blocked ? <TorBlockedPage /> : <>{children}</>;
}
